import { useDispatch, useSelector } from "react-redux";
import { USERALL, USERROLE, USERROLEALL } from "../../services/actions";
import React from "react";

import { ROLE, ROLEALL } from "../../services/actions";
import SearchableList from "../../libs/inputs/SearchableList";
import { Container, Button, Box, Grid, Typography, Badge } from "@mui/material";
import {
  BsBoxFill,
  BsPencilSquare,
  BsTrashFill,
  BsPlusSquareFill,
  BsKeyFill,
  BsCheckCircleFill,
  BsDashCircleFill,
} from "react-icons/bs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import Form from "./Form";
import MultiSelect from "../extra/MultiSelect";

export default function UserPermission() {
  const dispatch = useDispatch();
  const [defV, setDefV] = React.useState({});
  const [companies, setCompanies] = React.useState([]);
  const userallState = useSelector((state) => state?.userallState);
  const companyState = useSelector((state) => state?.companyState);
  let userroleState = useSelector((state) => state?.userroleState);
  let userroleallState = useSelector((state) => state?.userroleallState);
  const [userid, setUserid] = React.useState();
  const [selectedPer, setSelectePer] = React.useState([]);


  React.useEffect(() => {
    // dispatch({ type: `${COMPANY}_GET`, payload: 0 });
  }, []);

  React.useEffect(() => {
    setCompanies(companyState?.data?.results);
  }, [companyState?.data]);

  const addPermission = (id, role, action) => {
    let data = {
      id: userid,
      groups: [role],
      remove: action,
    };

    dispatch({
      type: `${USERROLE}_PATCH`, payload: data, callback: (resp) => {

      }
    });

    dispatch({
      type: `${USERROLEALL}_GET`,
      payload: userid,
    });
  };
  // const updatedBtn = (status) =>
  //   status ? (
  //     <BsCheckCircleFill color="green" />
  //   ) : (
  //     <BsDashCircleFill color="#c71616" />
  //   );
  return (
    <>
      <Box sx={{ p: 2 }}>
        <Box fontWeight={700} fontSize={14} minWidth={200}>
          {/* {user?.main_role} / User Permission */}
        </Box>
        <Grid container>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Form
              companies={companies}
              users={userallState?.data?.results || []}
              defaultValues={defV}
              onChange={(value, action) => {
                let url = "";
                // console.log("value", value)
                // if (action === "company") {
                //   url = `user/0/?filter_by={"companyuser__company":"${value}","is_active":true}`;
                //   if (value) {
                //     dispatch({
                //       type: `${USERALL}_GET`,
                //       payload: url,
                //     });
                //   }
                // }
                if (action === "users") {
                  setUserid(value)
                  if (value) {
                    dispatch({
                      type: `${USERROLEALL}_GET`,
                      payload: value,
                    });
                  }
                }
              }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <Typography sx={{ mt: 2 }}>Permissions</Typography>
            <MultiSelect
              //defaultValue={(defaultValues.project || projects).map((p) => p.id)} 
              options={[{ id: 1, name: "Add User" }, { id: 2, name: "Edit User" }, { id: 3, name: "Manager" }].map((role) => { return { id: role.id, label: role.name } })}
              value={selectedPer}
              defaultValue={[{ id: 1, name: "Add User" }] || []}
              onValueChange={(value) => {
                // setValue("role", value, { shouldValidate: false });
                // if (value && value.length) clearErrors("role");
              }}

            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid size={{ xs: 12, sm: 6 }} sx={{ my: 5, pt: 2 }}>
            <TableContainer sx={{ p: 3 }}>
              <Table
                sx={{ minWidth: 201 }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Role for User</TableCell>
                    <TableCell align="right">Select</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {userroleallState?.data?.group?.map((option) => (
                    <TableRow
                      key={option.name}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {option.name}
                      </TableCell>
                      <TableCell align="right">
                        {option.is_assigned ? (
                          <BsCheckCircleFill
                            color="green"
                            size={20}
                            onClick={() => addPermission(option.id, option.name, true)}
                          >
                            {/* {updatedBtn(false)} */}
                          </BsCheckCircleFill>
                        ) : (
                          <BsDashCircleFill
                            color="red"
                            size={20}
                            onClick={() => addPermission(option.id, option.name, false)}
                          >
                            {" "}
                            {/* {updatedBtn(true)} */}
                          </BsDashCircleFill>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

          </Grid>
        </Grid>
      </Box>
    </>
  );
}
